import { createContext } from "react";

// True once the visitor has dismissed the splash cover. Used to hold back
// scroll-in animations (like the DecodeText titles) until the site is actually
// visible, so nothing animates while hidden behind the splash.
export const EnteredContext = createContext(false);
